import { createBrowserRouter } from "react-router-dom";
import { Layout } from "./components/layout/Layout";
import Home from "./pages/Home";
import HowItWorks from "./pages/HowItWorks";
import Solutions from "./pages/Solutions";
import AIAutomation from "./pages/AIAutomation";
import DataProspecting from "./pages/DataProspecting";
import OutboundInfrastructure from "./pages/OutboundInfrastructure";
import WhyUniqReach from "./pages/WhyUniqReach";
import Results from "./pages/Results";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Book from "./pages/Book";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "how-it-works", element: <HowItWorks /> },
      { path: "solutions", element: <Solutions /> },
      { path: "technology/ai-automation", element: <AIAutomation /> },
      { path: "technology/data-prospecting", element: <DataProspecting /> },
      {
        path: "technology/outbound-infrastructure",
        element: <OutboundInfrastructure />,
      },
      { path: "why-uniqreach", element: <WhyUniqReach /> },
      { path: "results", element: <Results /> },
      { path: "about", element: <About /> },
      { path: "faq", element: <FAQ /> },
      { path: "book", element: <Book /> },
      { path: "contact", element: <Contact /> },
      { path: "privacy", element: <Privacy /> },
      { path: "terms", element: <Terms /> },
    ],
  },
  {
    path: "*",
    element: <Layout />,
    children: [{ index: true, element: <Home /> }],
  },
]);
